import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ModifiedFieldsService<T> {
  private readonly modifiedFieldsSubject = new BehaviorSubject<T>(null);
  public readonly modifiedFields$ = this.modifiedFieldsSubject.asObservable();

  isAvailable(): boolean {
    return this.modifiedFieldsSubject.getValue() !== null;
  }

  set modifiedFields(modifiedFields: T) {
    this.modifiedFieldsSubject.next(modifiedFields);
  }
}
